import React from 'react'

const StatusForm = () => {
  return (
    <div>StatusForm</div>
  )
}

export default StatusForm